interface DashboardHeaderProps {
  timeRange: "day" | "week" | "month" | "quarter" | "year";
  onTimeRangeChange: (
    value: "day" | "week" | "month" | "quarter" | "year"
  ) => void;
}
export function DashboardHeader({
  timeRange,
  onTimeRangeChange,
}: DashboardHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between  gap-5">
      <div>
        <p className="page-title">Command Center</p>
        <p className="page-subtitle">Welcome to your unified dashboard.</p>
      </div>
    </div>
  );
}
